import ProductGroupingPartialsTitleDesc from "./ProductGroupingPartialsTitleDesc.component";

export default ProductGroupingPartialsTitleDesc;
